import { CATALYST, ELEMENT } from '../enum';

export const naturalCatalysts = {
	[`${CATALYST.BLUE_GEMSTONE}`]: {
		id: 717,
		name: 'Blue Gemstone',
		comment: 'A gemstone that bolster the \'spiritual\' characteristic.',
	},
	[`${CATALYST.CYFAR}`]: {
		id: 7053,
		name: 'Cyfar',
		comment: 'A crystal that strengthen the \'stability\' characteristic.',
	},
	[`${CATALYST.RED_GEMSTONE}`]: {
		id: 716,
		name: 'Red Gemstone',
		comment: 'A gemstone that bolster the \'power\' characteristic.',
	},
	[`${CATALYST.YELLOW_GEMSTONE}`]: {
		id: 715,
		name: 'Yellow Gemstone',
		comment: 'A gemstone that bolster the \'mind\' characteristic.',
	},
};

export const synthesizedCatalysts = {
	[`${CATALYST.GARM_ESSENCE}`]: {
		id: 40083,
		name: 'Garm\'s Essence',
		comment: 'Essence with a strong the \'psychical\' characteristic. Need to be synthesize',
		isCraftable: true,
	},
	[`${CATALYST.IFRIT_ESSENCE}`]: {
		id: 40080,
		name: 'Ifrit\'s Essence',
		comment: 'Essence with a strong the \'aggression\' characteristic. Need to be synthesize',
		isCraftable: true,
	},
	[`${CATALYST.MAYA_ESSENCE}`]: {
		id: 40081,
		name: 'Maya\'s Essence',
		comment: 'Essence with a strong the \'permanence\' characteristic. Need to be synthesize',
		isCraftable: true,
	},
	[`${CATALYST.MISTRESS_ESSENCE}`]: {
		id: 40082,
		name: 'Mistress\'s Essence',
		comment: 'Essence with a strong the \'conscious\' characteristic. Need to be synthesize',
		isCraftable: true,
	},
};

export const catalysts = {
	...naturalCatalysts,
	...synthesizedCatalysts,
};

export const agents = {
	[`${ELEMENT.AIR}`]: [
		{
			id: 992,
			name: 'Wind of Verdure',
			comment: 'A minor boost to Air score.',
			quality: 0,
			air: 20,
			earth: 0,
			fire: 0,
			water: 0
		},
		{
			id: 996,
			name: 'Rough Wind',
			comment: 'Greatly enhance Air score.',
			quality: 0,
			air: 40,
			earth: 0,
			fire: 0,
			water: 0
		},
		{
			id: 40066,
			name: 'Prism Maxima',
			comment: 'Greatly enhance Air score and quality. Need to be synthesize.',
			quality: 20,
			air: 40,
			earth: 0,
			fire: 0,
			water: 0,
			isCraftable: true,
		}
	],
	[`${ELEMENT.EARTH}`]: [
		{
			id: 993,
			name: 'Green Live',
			comment: 'A minor boost to Earth score.',
			quality: 0,
			air: 0,
			earth: 20,
			fire: 0,
			water: 0
		},
		{
			id: 997,
			name: 'Great Nature',
			comment: 'Greatly enhance Earth score.',
			quality: 0,
			air: 0,
			earth: 40,
			fire: 0,
			water: 0
		},
		{
			id: 40065,
			name: 'Nature Maxima',
			comment: 'Greatly enhance Earth score and quality. Need to be synthesize.',
			quality: 20,
			air: 0,
			earth: 40,
			fire: 0,
			water: 0,
			isCraftable: true,
		}
	],
	[`${ELEMENT.FIRE}`]: [
		{
			id: 990,
			name: 'Red Blood',
			comment: 'A minor boost to Fire score.',
			quality: 0,
			air: 0,
			earth: 0,
			fire: 20,
			water: 0
		},
		{
			id: 994,
			name: 'Flame Heart',
			comment: 'Greatly enhance Fire score.',
			quality: 0,
			air: 0,
			earth: 0,
			fire: 40,
			water: 0
		},
		{
			id: 40064,
			name: 'Crimson Maxima',
			comment: 'Greatly enhance Fire score and quality. Need to be synthesize.',
			quality: 20,
			air: 0,
			earth: 0,
			fire: 40,
			water: 0,
			isCraftable: true,
		}
	],
	[`${ELEMENT.WATER}`]: [
		{
			id: 991,
			name: 'Crystal Blue',
			comment: 'A minor boost to Water score.',
			quality: 0,
			air: 0,
			earth: 0,
			fire: 0,
			water: 20
		},
		{
			id: 995,
			name: 'Mystic Frozen',
			comment: 'Greatly enhance Water score.',
			quality: 0,
			air: 0,
			earth: 0,
			fire: 0,
			water: 40
		},
		{
			id: 40067,
			name: 'Mana Maxima',
			comment: 'Greatly enhance Water score and quality. Need to be synthesize.',
			quality: 20,
			air: 0,
			earth: 0,
			fire: 0,
			water: 40,
			isCraftable: true,
		}
	],
};
